import * as Yup from 'yup';

export const REJECT_PARTICIPANT_VALIDATION_SCHEMA = Yup.object().shape({
  rejectionReason: Yup.string().required('Обязательное поле').max(250, 'Превышено максимальное число символов'),
  isRejectedBySecurityService: Yup.boolean().required(),
});
